import axios from 'axios'
import authHeader from './auth-header'

class request {

    static getService(url, data) {
        url = data ? url + '?' + new URLSearchParams(data).toString() : url;
        return new Promise((resolve, reject) => {
            axios.get(url, { headers: authHeader() }).then(res => {
                return resolve(res);
            }).catch((error) => {
                return reject(error);
            });
        });

    }

    static postService(url, data) {
        return new Promise((resolve, reject) => {
            axios.post(url, data, { headers: authHeader() }).then(res => {
                return resolve(res)
            }).catch((error) => {
                return reject(error);
            });
        });
    }

    static putService(url, data) {

        return new Promise((resolve, reject) => {
            axios.put(url, data, { headers: authHeader() }).then(res => {
                return resolve(res)
            }).catch((error) => {
                return reject(error);
            });
        });

    }

    static deleteService(url, data) {

        return new Promise((resolve, reject) => {
            axios.delete(url, { headers: authHeader(), data }).then(res => {
                resolve(res)
            }).catch((error) => {
                return reject(error);
            });
        });

    }

}


export default request;